import * as React from 'react';
import NarrowInfoContainer from '../components/NarrowInfoContainer';
import { renderNewTextField, renderErrorInfoText } from '../common/forms/FieldCreators';
import { LocalForm, Control, Errors } from 'react-redux-form';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { localizations } from '../localization/localization';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as LoginStore from './loginStore'
import * as validators from '../common/validators/formValidators'


interface FormModel {
    userName: string;
}

type ForgotPasswordProps = typeof LoginStore.actionCreators;

const ForgotPassword = (props: ForgotPasswordProps) => {

    const init = { userName: "" };

    return <LocalForm
        onSubmit={(values) =>props.resetPassword(values)}
        initialState={init}
    >
        <NarrowInfoContainer>
            <Grid item>
                <Typography variant="h6">{localizations.register.didYouForgetPassword}</Typography>
            </Grid>
            <Grid item style={{ width: 300, textAlign: "center" }}>
                <Typography variant="body2">{localizations.register.newPassword}</Typography>
            </Grid>
            <Grid item style={{ width: 300 }}>
                <Control.text model=".userName" validators={{isEmail: validators.isEmail}} validateOn={["blur", "change"]} component={renderNewTextField} label={localizations.common.email} />
                <Errors model=".username" show={{touched: true, focus: false}} messages={{isEmail: localizations.validation.notAnEmail}} wrapper={renderErrorInfoText} />
            </Grid>
            <Grid item>
                <Button variant="contained" color="secondary" type="submit">{localizations.actions.send}</Button>
            </Grid>
            <Grid item>
                <Link to="/login"><Button color="primary">{localizations.actions.toLoggingIn}</Button></Link>
            </Grid>
        </NarrowInfoContainer>
    </LocalForm>
}

export default connect(null, LoginStore.actionCreators)(ForgotPassword);


// WEBPACK FOOTER //
// ./src/login/ForgotPassword.tsx